"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));
/* eslint-disable */


var SVG = function SVG(props) {
  return react_1["default"].createElement("svg", __assign({}, props, {
    x: '0px',
    y: '0px',
    width: '50',
    height: '50',
    viewBox: '0 0 50 50',
    style: {
      fill: props.color || '#000'
    },
    xmlns: 'http://www.w3.org/2000/svg'
  }), react_1["default"].createElement("g", {
    id: 'surface1'
  }, react_1["default"].createElement("path", {
    d: 'M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z '
  })));
};

exports["default"] = SVG;
/* eslint-enable */